import Enum from "../../../../../enums/Enum";

const ClaimStatus = new Enum({
    CREATED: {name: "Created"},
    QUERIED: {name: "Queried"},
    AUDITED: {name: "Audited"},
    VERIFIED: {name: "Verified"},
    PENDING: {name: "Pending"},
    SUBMITTED: {name: "Submitted"},
    RESUBMITTED: {name: "Resubmitted"},
    REJECTED: {name: "Rejected"},
    APPROVED: {name: "Approved"}
});

ClaimStatus.remittanceStatus = [ClaimStatus.APPROVED, ClaimStatus.REJECTED];

// Statuses selectable when manually adjusting a claim; APPROVED/REJECTED are remittance-owned
ClaimStatus.manualStatuses = [
    ClaimStatus.CREATED, ClaimStatus.QUERIED, ClaimStatus.AUDITED, ClaimStatus.VERIFIED,
    ClaimStatus.PENDING, ClaimStatus.SUBMITTED, ClaimStatus.RESUBMITTED
];

export default ClaimStatus;
